import { useMemo } from 'react'

import { InputSelect, SelectProps } from './index'
import { useUserListContext } from '../../../hooks/context/useUserListContext'
import { RoleEnumType } from '@dpa/common/dist/prismaGenerated/inputTypeSchemas/RoleEnumSchema'

export function UserDropdownSelection({
  roles,
  fieldId,
  strValue,
  setStrValue,
  onBlur,
}: { roles?: Array<RoleEnumType> } & Omit<SelectProps, 'options'>) {
  const { allUserOptions, userById } = useUserListContext()
  const relevantUserOptions = useMemo(() => {
    if (roles === undefined || allUserOptions === undefined) {
      return allUserOptions
    }
    const options = allUserOptions.filter(
      (user) => user.roles === undefined || roles.every((role) => user.roles?.includes(role))
    )
    const currentUser = userById?.[Number(strValue)]

    if (currentUser == null || options.some((option) => option.key === strValue)) {
      return options
    }

    return [
      ...options,
      {
        key: strValue,
        value: currentUser.disabledAt == null
          ? `${currentUser.name} (mittlerweile andere interne Rolle)`
          : `${currentUser.name} (inaktiv)`,
        disabled: true,
      },
    ]
  }, [allUserOptions, roles, strValue, userById])

  return (
    <InputSelect
      fieldId={fieldId}
      strValue={strValue}
      optionsWithKey={relevantUserOptions}
      setStrValue={setStrValue}
      onBlur={onBlur}
    />
  )
}
